export default "__VITE_ASSET__I$i3SxvV__"